import { createAction } from '@reduxjs/toolkit';

export const ENABLE_ANSWERING_RULE_ACTION_TYPE = 'saga/enableAnsweringRule';
export const enableAnswerRuleAction = createAction(ENABLE_ANSWERING_RULE_ACTION_TYPE);
